import React from 'react';

type Props = React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>;

export const ExternalLink = React.forwardRef<HTMLAnchorElement, Props>((props, ref) => {
  return <a target={'_blank'} rel="noopener noreferrer" {...props} ref={ref} />;
});
